/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Signature_BlankInputs */

const es_co2_error_signature_blank = /** @type {(inputs: Error_Signature_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La firma debe incluir un nombre y un valor.`)
};

/**

* @param {Error_Signature_BlankInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_signature_blank = /** @type {((inputs?: Error_Signature_BlankInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Signature_BlankInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_signature_blank(inputs)
});